import type { CmtsSession } from "../session/cmtsSessionTypes.js";

export type CmtsExportDecision = {
  allowed: boolean;
  reason?: string | undefined;
  visibleColumns: readonly string[];
  auditEventType: string;
};

const EXTERNAL_BLOCKED_COLUMNS = new Set(["internalNotes", "auditTrail", "securityEvent", "rootCauseInternal", "managementComment", "restrictedEvidence", "createdBy"]);

export function decideCmtsExport(session: CmtsSession | null, requestedColumns: readonly string[]): CmtsExportDecision {
  if (!session) return { allowed: false, reason: "Session is required before export.", visibleColumns: [], auditEventType: "EXPORT_BLOCKED" };
  if (!session.permissionCodes.includes("REPORT.EXPORT") && !session.permissionCodes.includes("COMPLAINT.EXPORT")) {
    return { allowed: false, reason: "Export permission is required.", visibleColumns: [], auditEventType: "EXPORT_DENIED" };
  }
  const visibleColumns = session.isExternalUser ? requestedColumns.filter((column) => !EXTERNAL_BLOCKED_COLUMNS.has(column)) : requestedColumns;
  return { allowed: true, visibleColumns, auditEventType: "REPORT_EXPORTED" };
}

export function createCmtsExportAuditPayload(session: CmtsSession, entity: string, filters: Record<string, unknown>, rowCount: number) {
  return {
    id: `export-audit-${Date.now()}`,
    tenantId: session.tenantId,
    eventType: "REPORT_EXPORTED",
    actorId: session.userId,
    recordId: entity,
    occurredAt: new Date().toISOString(),
    summary: `${entity} export requested with ${rowCount} scoped rows.`,
    filters,
  };
}
